module.exports = function(ads) {
	'use strict'
	ads.directive('adsTxtDir',adsTxtDir);
	adsTxtDir.$inject=[];
	function adsTxtDir() {
		return {
			template: require('./partial/adsTxt.html'),
			controller:'adsTxtController',
			controllerAs:'vmat',
			link: function(scope, element, attrs, ctrl) {
				    
			}

		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/adsModule/adsTxt/js/directive/adsTxtDirective.js
// module id = 478
// module chunks = 0